import { AlertCircleIcon, RotateCcwIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import '../components/web-research-activity.css';

/** Feuille vierge en squelette, en attendant que le plan produise un premier aperçu. */
export function CanvasPlaceholder({ label }: { label: string }) {
  return (
    <div className="h-full overflow-y-auto bg-muted/35 px-4 py-6" data-testid="canvas-placeholder">
      <div aria-busy className="mx-auto flex w-full max-w-[48rem] flex-col gap-6 rounded-lg bg-background px-10 py-12 shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
        <p className="text-sm font-medium" role="status">
          <span className="t-shimmer" data-text={label}>{label}</span>
        </p>
        <Skeleton className="h-8 w-2/3" />
        <div className="flex flex-col gap-2.5">
          <Skeleton className="h-3.5 w-full" />
          <Skeleton className="h-3.5 w-11/12" />
          <Skeleton className="h-3.5 w-4/5" />
        </div>
        <Skeleton className="h-5 w-1/3" />
        <div className="flex flex-col gap-2.5">
          <Skeleton className="h-3.5 w-full" />
          <Skeleton className="h-3.5 w-10/12" />
        </div>
      </div>
    </div>
  );
}

export function CanvasLoadError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 bg-muted/35 px-6 text-center text-sm" role="alert">
      <AlertCircleIcon className="size-6 text-destructive" aria-hidden />
      <p className="max-w-sm text-muted-foreground">{message}</p>
      <Button onClick={onRetry} size="sm" type="button" variant="outline">
        <RotateCcwIcon className="size-3.5" aria-hidden />
        Réessayer
      </Button>
    </div>
  );
}
